import { useQuery } from '@hooks/reactQuery';

import { portalProjects } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getPortalProjectsList } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';

import { IItemsResponse } from '@interfaces/common/response';
import { IProjectDTO } from '@interfaces/portal/dto/projectManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_PROJECTS_LIST } from '@constants/queryKeys';

interface IUseQueryPortalProjectsReturned {
	isLoadingPortalProjects: boolean;
	countOfRecords: number;
	portalProjectsList: Array<IProjectDTO>;
}

export const useQueryPortalProjects = (): IUseQueryPortalProjectsReturned => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		status,
	} = useAppSelector(portalProjects);

	const {
		data: portalProjectsList,
		isLoading: isLoadingPortalProjects,
		isFetching: isFetchingPortalProjects,
	} = useQuery<IItemsResponse<IProjectDTO>>({
			queryKey: [
				GET_PORTAL_PROJECTS_LIST,
				{
					page,
					pageSize,
					searchValue,
					sortFieldName,
					sortDirection,
					status,
				},
			],
			queryFn: extractQueryParams(getPortalProjectsList),
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalProjects: isLoadingPortalProjects || isFetchingPortalProjects,
		portalProjectsList: portalProjectsList?.items || [],
		countOfRecords: portalProjectsList?.count || 0,
	};
};
